/**
 * App Supporters - List of social media supporters
 *
 * Add new supporters here and they will automatically appear
 * in the scrolling ticker on the website banner.
 *
 * Format: { handle: '@username', platform: 'tiktok' | 'instagram' | '' }
 */

export const APP_SUPPORTERS = [
  { handle: '@stelladigidesign', platform: 'tiktok' },
  { handle: '@coloured_by_helene', platform: 'tiktok' },
  { handle: '@fox.wolf.art', platform: 'tiktok' },
  { handle: 'Soph', platform: '' },
  { handle: 'Susanne', platform: '' },
  { handle: '@a_stew', platform: '' },
  { handle: '@start2create', platform: 'tiktok' },
  { handle: '@brightpinecreations', platform: 'tiktok' },
  { handle: '@jessynicoleb', platform: '' },
];
